// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-82336308","scoped":true,"hasInlineConfig":false}!./src/components/nudge-console/EditCampaign.css
// module id = i/Xv
// module chunks = 1